module.exports = __webpack_public_path__ + "static/media/testfile_sscmganholefilling.4a0df74d.zip";